export const BANNER_VIDEO_1_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Banner Slides (max 4)",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_desktop_image: "",
    meta_mobile_image: "",
    meta_alt_image: "Banner",
    meta_priority: 1,
    meta_status: true,
    meta_click_action: "lead_drop",
    meta_video_link: "",
    meta_redirect_url: "",
  },

  BANNER_VIDEO_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000 ",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "slide_frequency",
      label: "Slide Frequency (ms)",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Auto-scroll interval in milliseconds (e.g., 5000)",
      required: false,
      defaultValue: 5000,
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Desktop Image",
      fieldName: "meta_desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Banner Image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Mobile Image",
      fieldName: "meta_mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Banner Image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Alt Text",
      fieldName: "meta_alt_image",
      value: "Banner",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Text",
      required: false,
      defaultValue: "Banner",
    },
    {
      header: "Click Action",
      fieldName: "meta_click_action",
      value: "lead_drop",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "On banner click",
      required: true,
      defaultValue: "lead_drop",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Lead Drop (Form popup)", value: "lead_drop" },
        { label: "Video (Play video)", value: "video" },
      ],
    },
    {
      header: "Video Link (highest priority)",
      fieldName: "meta_video_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "YouTube embed URL (when Click Action is Video)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Redirect URL",
      fieldName: "meta_redirect_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "Optional. If set, banner click opens this URL instead of the lead form",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Order (1-4)",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this slide",
      defaultValue: true,
    },
  ],
};
